import {v4 as uuidv4} from "uuid";
import {BUCKET_NAME, REGION} from "./config";
import {DeleteObjectCommand, PutObjectCommand, S3Client} from "@aws-sdk/client-s3";
import {showErrorNotification} from "../components/Elements/NotificationUtils";
import {getAWSCredentials} from "./DynamoDB";

export const createS3Client = (idToken) => {
    return new S3Client({
        region: REGION,
        credentials: getAWSCredentials(idToken),
    });
};
// Upload an image to S3
export const uploadImageToS3 = async (imageFile, idToken) => {
    const s3Client = createS3Client(idToken);
    const uniqueFileName = `${uuidv4()}-${imageFile.name}`;
    const arrayBuffer = await imageFile.arrayBuffer(); // Convert to ArrayBuffer for AWS S3

    const params = {
        Bucket: BUCKET_NAME,
        Key: uniqueFileName,
        Body: arrayBuffer,
        ContentType: imageFile.type || 'application/octet-stream',
    };

    try {
        await s3Client.send(new PutObjectCommand(params));
        return `https://${BUCKET_NAME}.s3.${REGION}.amazonaws.com/${uniqueFileName}`;
    } catch (error) {
        console.error("Error uploading image:", error);
        return null;
    }
};
export const deleteImageFromS3 = async (imageUrl, idToken) => {
    const s3Client = createS3Client(idToken);
    const key = imageUrl.split('/').pop(); // Extract the filename from the URL

    const params = {
        Bucket: BUCKET_NAME,
        Key: key,
    };

    try {
        await s3Client.send(new DeleteObjectCommand(params));
    } catch (error) {
        showErrorNotification("Teppich wurde nicht gelöscht")
        console.error("Error deleting image:", error);
    }
};